module.exports = __webpack_public_path__ + "img/package.4716cc3e.png";